export default __webpack_public_path__ + "static/media/190.3f86d4d9.gif";